import { render, staticRenderFns } from "./import-transfer-order.vue?vue&type=template&id=017b8c20&"
import script from "./import-transfer-order.vue?vue&type=script&lang=ts&"
export * from "./import-transfer-order.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports